import {apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/email/v1`;

const saveSmtpConfig = smtpConfig => {
  return acerillAuthenticatedAxios
    .put(
      `${baseUrl}/smtp-configs/${encodeURIComponent(smtpConfig.id)}`,
      smtpConfig
    )
    .then(response => response.data);
};

const findSmtpConfig = id => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/smtp-configs/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const findSmtpConfigSummaries = () => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/smtp-configs`)
    .then(response => response.data);
};

const deleteSmtpConfig = id => {
  return acerillAuthenticatedAxios
    .delete(`${baseUrl}/smtp-configs/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const emailV1Client = {
  saveSmtpConfig,
  findSmtpConfig,
  findSmtpConfigSummaries,
  deleteSmtpConfig,
};

export default emailV1Client;
